import { render, staticRenderFns } from "./EditarPromocionDialogComponent.vue?vue&type=template&id=30617dcc"
import script from "./EditarPromocionDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarPromocionDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports